import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=32159b18&scoped=true"
import script from "./PersonSelect.vue?vue&type=script&lang=js"
export * from "./PersonSelect.vue?vue&type=script&lang=js"
import style0 from "./PersonSelect.vue?vue&type=style&index=0&id=32159b18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32159b18",
  null
  
)

export default component.exports